<template>
    <div class="calendar" >
        <p class="day">
            {{ timenow.day() | weekname }}
        </p>
        <div class="date-wrap">
            <div class="date">
                {{ timenow.format('DD') }}
            </div>
        </div>
        
        <p class="month">
            Tháng {{ timenow.format('MM') }}
        </p>
        <p class="lunar-date">
            {{ lunar[0] }}/{{ lunar[1] }} {{ lunarYear }}
        </p>

    </div>
</template>
<script>

import amlich from 'amlich';
import moment from 'moment';
export default {
    name: 'Calendar',
    props:['lunar'],
    data() {
        return {
            timenow: '',
            lunar: '',
            lunarYear: '',
            
        }
    },
    props:['qr'],
    methods: {
        time() {
        var self = this
        this.timenow = moment()

        setInterval(()=>{
            var self = this
            this.timenow = moment()
            // console.log(this.timenow.format('Y'));
            this.lunar = amlich.convertSolar2Lunar(parseInt(this.timenow.format('D')),parseInt(this.timenow.format('M')),parseInt(this.timenow.format('Y')),0)
            // this.lunarYear = amlich.getYearCanChi(this.lunar[2]);
            // console.log(this.lunar);

            var CAN = new Array("Giáp", "Ất", "Bính", "Đinh", "Mậu", "Kỷ", "Canh", "Tân", "Nhâm", "Quý");
            var CHI = new Array("Tý", "Sửu", "Dần", "Mão", "Thìn", "Tỵ", "Ngọ", "Mùi", "Thân", "Dậu", "Tuất", "Hợi");
            var year = this.lunar[2];
            this.lunarYear = CAN[(year+6) % 10] + " " + CHI[(year+8) % 12];
        }, 1000)},
    },
    created: function() {
        this.time();
        
    }
}
</script>

<style scoped>
.calendar{
    padding: 20px;
}
.day{
    font-weight: 500;
    font-size: 2em;
    margin-bottom: 10px;
}
.date-wrap{
    background: url(../assets/bg-number.png) no-repeat;
    background-size: 100%;
    color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
}
.date{
    line-height: 1em;
    font-family: 'Acumin Pro Bold';
    margin-bottom: 0px;
    font-size: 15em;
    font-weight: bold;
}
.month{
    margin-top: -30px;
    margin-bottom: 0px;
    font-size: 3em;
    font-weight: bold;
}
.lunar-date{
    color:red;
    font-size: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar.vue